import { MonthPickerInput } from '@mantine/dates';

export default MonthPickerInput.extend({
  defaultProps: {
    allowDeselect: true,
    clearable: true,
    size: 'md',
  },
});
